import * as helper from './../../../../../VX/View/Assets/Js/helper';
import Questionbox from './Questionbox';
import AlertBox from './AlertBox';

export default class Section1 {
	constructor() {
		let boxes = helper.$('#section1 .question-box-1');
		this.alertBox = new AlertBox(helper.$('#section1'));
		this.boxes = [];

		for (let box of boxes) {
			this.boxes.push(new Questionbox(box));
		}
	}

	isValid() {
		for (let box of this.boxes) {
			if (box.isSelected()) {
				this.alertBox.hide();
				return true;
			}
		}

		this.alertBox.show('Bitte wähle mindestens ein Erlebnis aus!');
		return false;
	}
}
